export default {
	'topBar.issuesHistory': 'Issues History',
	'topBar.projectManagement': 'Project Management',
	'topBar.typeToSearch': 'Search...',
	'topBar.findPages': 'Find pages...',
	'topBar.actions': 'Actions',
	'topBar.status': 'Status',
	'topBar.profileMenu.hello': 'Hello',
	'topBar.profileMenu.activeUser': 'Login as',
	'topBar.profileMenu.billingPlan': 'Billing Plan',
	'topBar.profileMenu.role': 'Role',
	'topBar.profileMenu.email': 'E-mail',
	'topBar.profileMenu.phone': 'Phone',
	'topBar.profileMenu.editProfile': 'Edit Profile',

	'admin.management': 'Management',
	'admin.role': 'Role',
	'admin.roles': 'Roles',

	'actions.accept': 'Accept',
	'actions.add': 'Add',
	'actions.back': 'Back',
	'actions.begin': 'Begin',
	'actions.cancel': 'Cancel',
	'actions.close': 'Close',
	'actions.continue': 'Continue',
	'actions.create': 'Create',
	'actions.delete': 'Delete',
	'actions.download': 'Download',
	'actions.edit': 'Edit',
	'actions.edit.item': 'Edit {{ item }}',
	'actions.export': 'Export “{{ name }}” for {{ num }} {{ participantNumber }}',
	'actions.exportAll': 'Export “{{ name }}” for all participants',
	'actions.exportOne': 'Export “{{ name }}”',
	'actions.hide': 'Hide',
	'actions.lock_screen': 'Lock Screen',
	'actions.login': 'Log In',
	'actions.logout': 'Logout',
	'actions.manage': 'Manage',
	'actions.new.participant': 'New Participant',
	'actions.new.project': 'New Project',
	'actions.new.user': 'New User',
	'actions.next': 'Next',
	'actions.next_question_group': 'Next Test',
	'actions.OK': 'OK',
	'actions.open': 'Open',
	'actions.openAs': 'Open As',
	'actions.print': 'Print {{ name }}',
	'actions.randomization.start': 'Start Randomization',
	'actions.randomization.reset': 'Reset Randomization',
	'actions.restart': 'Restart',
	'actions.save': 'Save',
	'actions.select': 'Select {{ selectItem }}',
	'actions.searchFor': 'Search {{ searchItem }}',
	'actions.show': 'Show',
	'actions.show_participant_detail': 'to Participant-Details',
	'actions.show_participant_overview': 'to Participant-Overview',
	'actions.show_participant_overview_search': 'to Participant-Search',
	'actions.deselect_participant': 'deselect Participant',
	'actions.show_user_detail': 'to User-Details',
	'actions.show_workflow': 'to Overview',
	'actions.skip_question_group': 'Skip Test',
	'actions.start': 'Start',
	'actions.restartTest': 'Restart Test',
	'actions.starttest': 'Start Test',
	'actions.stop': 'Stop',
	'actions.goToTest': 'Go To Test',

	'btn.privacy_protection': 'Privacy Protection',

	'datePicker.week': 'Week',
	'datePicker.calendar': 'Calendar',
	'datePicker.clear': 'Clear',
	'datePicker.today': 'Today',
	'datePicker.month.january': 'January',
	'datePicker.month.february': 'February',
	'datePicker.month.march': 'March',
	'datePicker.month.april': 'April',
	'datePicker.month.may': 'May',
	'datePicker.month.june': 'June',
	'datePicker.month.july': 'July',
	'datePicker.month.august': 'August',
	'datePicker.month.september': 'September',
	'datePicker.month.october': 'October',
	'datePicker.month.november': 'November',
	'datePicker.month.december': 'December',
	'datePicker.day.monday': 'Monday',
	'datePicker.day.monday.short': 'Mon',
	'datePicker.day.tuesday': 'Tuesday',
	'datePicker.day.tuesday.short': 'Tue',
	'datePicker.day.wednesday': 'Wednesday',
	'datePicker.day.wednesday.short': 'Wed',
	'datePicker.day.thursday': 'Thursday',
	'datePicker.day.thursday.short': 'Thu',
	'datePicker.day.friday': 'Friday',
	'datePicker.day.friday.short': 'Fri',
	'datePicker.day.saturday': 'Saturday',
	'datePicker.day.saturday.short': 'Sat',
	'datePicker.day.sunday': 'Sunday',
	'datePicker.day.sunday.short': 'Sun',
	'datePicker.format': 'MM/dd/yyyy',

	'device.override': 'Override Hardware',
	'device.TouchScreen': 'Touch Screen',
	'device.ButtonDevice': 'Vita React',
	'device.TappingPen': 'Vita Pen',
	'device.ExternalAudiometry': 'External Audiometry',
	'device.Audiometry_Sh_HDA_300__Sb_X_FI_HD': 'Audiometry - Sennheiser HDA 300 + SB X-Fi HD',
	'device.Audiometry_Sh_HDA_300__Sb_X_G1__Th_PS_TPY_2003_KBB': 'Audiometrie - Sennheiser HDA 300 + SB X G1 + Thomann pro snake TPY 2003 KBB Adapter',
	'device.Audiometry_bd_DT_770_PRO_80__Sb_X_FI_HD': 'Audiometry - beyerdynamic DT-770 Pro/80 + SB X-Fi HD',
	'device.Audiometry_bd_DT_770_PRO_32__Sb_X_G1': 'Audiometry - beyerdynamic DT-770 Pro/32 + SB X G1',
	'device.ExternalBicycleErgometer': 'Bicycle Ergometer (external)',
	'device.SoundDevice': 'Sound Device',
	'device.CalibratedHeadphones': 'Calibrated Headphones',

	'export.modal.title': 'Please select the tables you want to export.',
	'export.label': 'Tables',
	
	'form.input.minlength': 'There have to be {{ requiredLength }} characters (currently {{actualLength}}).',
	'form.input.required': '{{ itemName }} requires input',
	'form.submit.assign': 'Assign',

	'health.age': 'Age',
	'health.age_bio': 'Biological Age',
	'health.weight': 'Weight',

	'input.string.error.length.minMax': 'The input string must be between {{ minLength }} and {{ maxLength }} characters.',
	'input.string.error.length.max': 'The input string must not be more than {{ maxLength }} characters.',
	'input.string.error.length.min': 'The input string must contain at least {{ minLength }} characters',
	'input.string.error.required': 'Input required',
	'input.string.error.length.unknownError': 'There has been an error in the input.',
	
	'message.confirm.randomization.reset': 'Are you sure you want to reset the randomization classification for this participant?',
	'message.confirm.randomization.start': 'Are you sure you want to start the randomisation? This step can not be reversed.',
	'message.info.projectrole.notassigned': 'This user is not assigned to this project',
	'message.info.projectrole.notpermitted': 'You do not have permission to change this user\'s roles',
	'message.warning.participant.noneLoaded.description': 'No participant has been selected to perform this workflow with.',
	'message.warning.participant.noneLoaded.title': 'No participant loaded',
	'message.warning.privacy_protection.description': '<< >>',
	'message.warning.privacy_protection.title': 'Privacy Protection Mode',
	'message.warning.project.noneLoaded.description':
		'Please select an active project.',
	'message.warning.project.noneLoaded.title': 'No project loaded',
	'message.warning.input.rangeLow': 'The entered value must not be lower than {{rangeHigh}}{{unit}}',
	'message.warning.input.rangeHigh': 'The entered value must not be higher than {{rangeHigh}}{{unit}}',
	'message.warning.viewMode.notRecommended.title': 'Not recommended',
	'message.warning.viewMode.notRecommended.description': 'The selected view is not recommended for this item.',
	'message.warning.not_finished_sufficient': 'Could not complete task. Some necessary questions are still pending.',
	'message.warning.input.invalid': 'Invalid input',
	'message.warning.devices_missing': 'The following devices are missing, ' +
		'so the next step needs to be completed using an alternate input.',
	'message.warning.falseReactionInput': 'Input has been recognized as a false attempt. It won\'t be recorded.',
	'message.warning.sameUser': 'Same user',
	'message.warning.sameUser_description': 'A user can not edit their own roles.',
	'message.warning.noPermit': 'No permission',
	'message.warning.noPermit_description': 'You are not permitted to make changes on this page.',
	'message.warning.old_password.missing': 'Input "Old Password" required.',
	'message.warning.password.missing': 'Input "New Password" required.',
	'message.warning.password_confirm.missing': 'Input "Confirm Password" required.',
	'message.warning.password_not_match': 'Passwords do not match.',
	'message.warning.workflow.unstartedAndNoPermission': 'This item has not been started yet and you do not have the required permission to start it.',
	'message.error.password.incorrect': 'Password is incorrect.',
	'message.error.delete.user': 'User cannot be deleted.',

	'misc.developer_settings': 'Developer Settings',
	'misc.documentation': 'Documentation',
	'misc.forParticipants': 'For {{ num }} participants',
	'misc.hint': 'Hint',
	'misc.project': 'Project',
	'misc.projects': 'Projects',
	'misc.privacy_policy': 'Privacy Policy',
	'misc.primary_color': 'Set primary color',
	'misc.settings': 'Settings',
	'misc.switch_theme': 'Switch Dark / Light Theme',
	'misc.demo_mode': 'Demo Mode',
	'misc.actualAgeLabel': 'Calendar age ',
	'misc.bfaLabel': 'Your Biofunctional Age (BFA) ',
	'misc.actualAgeAbbreviation': ' years',
	'misc.bfaAbbreviation': ' YE',
	'misc.referencePopulationLabel': 'Reference population Central Europe',
	'misc.welcome': 'Welcome on the Gesundheitsplattform',

	'participants.add': 'Add new Participant',
	'participants.cancel': 'Cancel Process',
	'participants.create': 'Create new Participant',
	'participant.delete.modal.text': 'Are you sure you want to delete participant {{ pid }}?',
	'participant.delete.modal.title': 'Delete Participant {{ pid }}',
	'participant.data.key.projects': 'Projects',
	'participants.edit': 'Save',
	'participant.export': 'Export',
	'participants.toList': 'Leave Details',
	'participants.export': 'Export {{ number }} participants',

	'projects.change_title': 'Change Active Project',
	'projects.change_text': 'Are you sure you want to change the currently active project? The currently active participant will be reset.',
	'projects.id': 'Project-ID',
	'projects.name': 'Project Name',
	'projects.server_id': 'Server-ID',
	'projects.add': 'Create New Project',
	'projects.create': 'Create Project',
	'projects.cancel': 'Abort',
	'projects.doEdit': 'Save changes',
	'projects.uploadArchive': 'Upload project configuration from archive',

	'person.admin': 'Administrator',
	'person.analyst': 'Analyst',
	'person.casemanager': 'Case Manager',
	'person.doctor': 'Physician',
	'person.expertier': 'Expertier',
	'person.participant': 'Participant',
	'person.participants': 'Participants',
	'person.therapist': 'Therapist',
	'person.user': 'User',
	'projects.error.creationFailed': 'Project could not be created',
	'projects.error.editFailed': 'Project could not be edited',
	'projects.error.archiveUploadFailed': 'Project configuration could not be uploaded',

	'workflow.abortSpecial': 'Abort',
	'workflow.akustischeReaktion.started': 'Test is running. Listen for the sound and stop as soon as you hear it.',
	'workflow.akustischeReaktion.ready': 'Test is ready. Click on the button "Start Test" to start.',
	'workflow.optischeReaktion.ready': 'Test is ready. Click on the button "Start Test" to start.',
	'workflow.beginSpecial': 'Start',
	'workflow.compactView': 'Compact View',
	'workflow.cancel': 'Quit editing',
	'workflow.continue': 'Continue editing',
	'workflow.continueInCompact': 'continue in Compact Mode',
	'workflow.continueInWizard': 'continue in Distraction-Free Wizard',
	'workflow.distractionfreeWizard': 'Distraction-free Wizard',
	'workflow.end': 'Finish editing',
	'workflow.endView': 'Finish view',
	'workflow.endWarning': 'Are you sure you want to finish the current step?',
	'workflow.examination': 'Examination',
	'workflow.execute': 'Execute {{ item }}',
	'workflow.hotWire.finished': 'Finished',
	'workflow.hotWire.start': 'Please touch the green area to start',
	'workflow.hotWire.started': '',
	'workflow.hoerverlust.started': 'Test is running. Listen for the sound. Press stop when you hear it and when you can\'t hear it anymore.',
	'workflow.hoerverlust.ready': 'Test is ready. Click on the button "Start Test" to start.',
	'workflow.hoerverlust.risingStop': 'Press stop when you hear the sound.',
	'workflow.hoerverlust.fallingStop': 'Press stop when you don\'t hear the sound anymore',
	'workflow.input.confirm': 'Input confirmed',
	'workflow.modal.finish.text': 'Are you sure you want to finish and lock in the results?',
	'workflow.modal.finish.title': 'Confirm Results',
	'workflow.modal.missingdevices.title': 'Missing Devices',
	'workflow.modal.missingdevices.text': 'Following devices are missing in order to fulfill the test requirements:',
	'workflow.modal.missing_value.title': 'Use Missing Values',
	'workflow.modal.missing_value.text': 'Are you sure you want to use missing values?',
	'workflow.modal.reset.title': 'Reset?',
	'workflow.modal.reset.text': 'Are you sure you want to reset the step?',
	'workflow.modal.transition.bulk.titel': 'Proceed multiple tasks',
	'workflow.modal.transition.bulk.text': 'The choice will be used to proceed all available task for all selected participants. ' +
		'Do you want to {{ transitionAction }} ({{ num }} Participants).',
	'workflow.reset': 'Reset',
	'workflow.missing_value_epilog': 'Missing Values in use.',
	'workflow.missing_value_in_use': 'Missing Values in use.',
	'workflow.needsWizard': 'This test requires the wizard to be performed.',
	'workflow.nextPage': 'Next Page',
	'workflow.next_labyrinth': 'Next Labyrinth',
	'workflow.noDevices': 'This test can only be run in full screen mode and also has specific hardware requirements that your system does not meet. ' +
		'It is recommended to run the test on another system.',
	'workflow.openManualInput': 'Enter values manually',
	'workflow.openManualInputCompact': 'Open manual Input',
	'workflow.closeManualInputCompact': 'Close manual Input',
	'workflow.editManualInputValuesCompact': 'Edit values',
	'workflow.newOpenManualInput': 'Enter new values manually',
	'workflow.overview': 'Overview',
	'workflow.previousPage': 'Previous Page',
	'workflow.quitOverview': 'Leave Overview',
	'workflow.quitWizard': 'Leave Wizard',
	'workflow.randomization': 'Randomization',
	'workflow.randomization.allocated': 'The participant has been assigned to: "{{group}}".',
	'workflow.randomization.pending': 'After completion of randomization the participant will be assigned either to the intervention group or to the control group. ' +
		'Once complete, this assignment can not be reversed.',
	'workflow.resetData': 'Reset Questionnaire',
	'workflow.resetMessage.warning': 'Are you sure you want to reset all data of this step?',
	'workflow.resetReport': 'Recompute Reports',
	'workflow.restartSpecial': 'Restart',
	'workflow.start': 'Start editing',
	'workflow.show': 'Show',
	'workflow.showInCompact': 'show in Compact Mode',
	'workflow.showInWizard': 'show in Distraction-Free Wizard',
	'workflow.show_Overview': 'Show Overview',
	'workflow.show_OverviewInCompact': 'show overview in Compact Mode',
	'workflow.show_OverviewInWizard': 'show overview in Distraction-Free Wizard',
	'workflow.startInCompact': 'start in Compact Mode',
	'workflow.startInWizard': 'start in Distraction-Free Wizard',
	'workflow.test.completed': 'The test has been completed',
	'workflow.test.result.number': 'Test result {{num}}',
	'workflow.test.result.measurement': 'Measurement {{num}}',
	'workflow.test.started': 'Test in progress',
	'workflow.test.colorWord.TextOnly': 'Please read the words.',
	'workflow.test.colorWord.ColorOnly': 'Please name the colors.',
	'workflow.test.colorWord.ColorText': 'Please name the font colors.',
	'workflow.test.colorWord.verbalReaction': 'Verbal responsiveness',
	'workflow.test.colorWord.cognitiveReaction': 'Cognitive responsiveness',
	'workflow.test.colorWord.cognitiveAdaptability': 'Cognitive adaptability',
	'workflow.test.colorWord.redGreenBlind': 'Rot-Grün-Sehschwäche vorhanden',
	'workflow.test.digitalHearingLoss.averageByInput': 'Averages according to inputs',
	'workflow.test.digitalHearingLoss.averageByCompute': 'Averages according to calculations',
	'workflow.test.labyrinth.labyrinth': '{{num}} Labyrinth',
	'workflow.test.labyrinth.repetitiveErrors': 'Repetitive errors',
	'workflow.test.labyrinth.trialMistake': 'Trial mistakes',
	'workflow.test.tapping.cycle': 'Strokes test cycle {{num}}',
	'workflow.wait.input': 'Waiting for input',
	'workflow.wizardOpen': 'Open in Wizard',

	'result.correct': 'Correct Answers: ',
	'result.error': 'Wrong Answers: ',
	'result.time': 'Time: ',

	'search.no_results': 'No results found',
	'search.search_results': 'Search results',
	'search.too_many_results': 'Too much search results',
	'search.too_many_results_more': 'Please precise your search term',
	'search.use_extended_search': 'Advanced Search',

	'status.finished': 'finished',
	'status.locked': 'locked',
	'status.started': 'started',
	'status.unstarted': 'not started',
	'status.queries.open': 'open queries',
	'status.queries.responded': 'responded queries',
	
	'result.value': 'Value',

	'ui.showcase.primary': 'Primary',
	'ui.showcase.secondary': 'Secondary',
	'ui.showcase.delete': 'Delete',
	'ui.showcase.pureButton': 'Only Buttons',
	'ui.showcase.buttonIcon': 'Buttons with Icon',
	'ui.showcase.splitbuttonIcon': 'Splitbuttons with Icon',
	'ui.showcase.splitbuttonCallback': 'Splitbuttons with callback and divider',
	'ui.showcase.pureIcons': 'Only Icons',
	'ui.showcase.distractionFreeButtons': 'Distraction-free Wizard Buttons',

	'unit.milliseconds.short': 'msec',
	'unit.seconds.short': 'sec',

	'user.add': 'Add new User',
	'user.createdDate': 'Creation Date',
	'user.data': 'User Data',
	'user.roles': 'User Roles',
	'user.username': 'Username',
	'user.firstname': 'Firstname',
	'user.surname': 'Surname',
	'user.birthday': 'Birthday',
	'user.uid': 'User ID',
	'user.email_short': 'E-mail',
	'user.email_long': 'E-mail Address ',
	'user.name': 'Name',
	'user.password': 'Password',
	'user.oldPassword': 'Old Password',
	'user.newPassword': 'New Password',
	'user.password_confirm': 'confirm Passwort',
	'user.projectsAndRoles': 'Project and role assignment ',
	'user.delete.modal.text': 'Are you sure that you want to delete user {{ username }}?',
	'user.delete.modal.title': 'Delete user {{ username }}',
	'user.editroles.title': '{{ username }} - Project and Role assignment',
	'user.editroles.roles': 'User roles',
	'user.editroles.groups': 'User groups',

	'word.ageIndex': 'Age Index',
	'word.description': 'Description',
	'word.icon': 'Icon',
	'word.iconName': 'Icon Name',
	'word.meaning': 'Meaning',
	'word.measurement': 'Measurement',
	'word.num.first': 'First',
	'word.num.second': 'Second',
	'word.num.third': 'Third',
	'word.participant.singular': 'participant',
	'word.participant.plural': 'participants',
	'word.set': 'Set',
	'word.left': 'Left',
	'word.leftEar': 'Left ear',
	'word.right': 'Right',
	'word.rightEar': 'Right ear',
	'word.both': 'Both',
	'word.time': 'Time',
	'word.error': 'Error',
	'word.missing_value': 'Missing Value',
	'word.missing_value_remove_with_title': 'Remove Missing Value ({{missing_value}})',
	'word.missing_value_use_with_title': 'Use Missing Value ({{missing_value}})',
	'word.years': 'Years',
	'word.workflow-item': 'workflow step',
	
	'login-dialog.login': 'Approve',
	
	'generic.confirm.title': 'Approve?',
	'generic.confirm.yes': 'Yes',
	'generic.confirm.no': 'No',
	
	'protocol.title': 'Protocol',
	
	'timeline.workflow-item-unknown': 'a workflow step',
	'timeline.participant-unknown': 'a participant',
	'timeline.participant-create': '{{ username }} created {{ participant }}',
	'timeline.participant-update': '{{ username }} changed {{ participant }}',
	'timeline.participant-delete': '{{ username }} removed {{ participant }}',
	'timeline.workflow-item-inprogress': '{{ username }} edited {{ workflowItem }} for {{ participant }}',
	'timeline.workflow-item-completed': '{{ username }} completed {{ workflowItem }} for {{ participant }}',
	'timeline.workflow-item-inprogress-reset': '{{ username }} reset {{ workflowItem }} for {{ participant }}',
	'timeline.workflow-item-completed-reset': '{{ username }} reset {{ workflowItem }} for {{ participant }}',
	'timeline.config-archive-upload': '{{ username }} changed a project configuration',
	'timeline.custom-state-change': '{{ username }} changed the state of {{ workflowItem }} for {{ participant }}',
	
	'query.card.title': 'Queries',
	'query.create.title': 'Create',
	'query.create.question.label': 'Concerning question',
	'query.create.question.placeholder': 'no question selected',
	'query.create.query': 'Query',
	'query.create.button': 'Post',
	'query.edit.opened': 'Opened',
	'query.edit.responded': 'Responded',
	'query.edit.comment': 'Comment',
	'query.edit.button.respond': 'Respond',
	'query.edit.button.comment': 'Comment',
	'query.edit.button.close': 'Close',
	'query.empty': 'There are no open Queries',
};
